import { initializeIcons, registerIcons, setIconOptions } from '@fluentui/react';
import { CscBrandPalette } from '../../data-types/styles/CscBrandPalette';
import { ICorptaxThemeSettings } from '../../data-types/styles/ICorptaxThemeSettings';

setIconOptions({
    disableWarnings: true,
});
initializeIcons('https://cloud.corptax.com/cdn/vendor/fluentui/font-icons-mdl2/8.4.13/fonts/');
registerIcons({
    fontFace: {
        fontFamily: `'csc_icons'`,
    },
    icons: {
        CscBell: '\uE934',
        CscFavorites: '\ue9d8',
        CscCart: '\uEB00',
        CscHelp: '\uEAD0',
        CscAssistant: '\uea0e',
        CscHamburgerMenu: '\ue9fc',
    },
});

const defaultCscBrandPalette = new CscBrandPalette();

export const corptaxFluentUiTheme: ICorptaxThemeSettings = {
    palette: {
        themePrimary: '#003b5c',
        themeLighterAlt: '#cfe1eb',
        themeLighter: '#a7c7d9',
        themeLight: '#84afc8',
        themeTertiary: '#6498b6',
        themeSecondary: '#4882a4',
        themeDarkAlt: '#306e92',
        themeDark: '#1c5b80',
        themeDarker: '#0c4a6e',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    },
    extendedPalette: {
        accent: '#00B2A9',
        accentDarker: '#007f79',
        highlight: '#EBF6FD',
    },
    brandPalette: defaultCscBrandPalette,
};

export const blackTheme: ICorptaxThemeSettings = {
    palette: {
        themePrimary: '#000000',
        themeLighterAlt: '#898989',
        themeLighter: '#737373',
        themeLight: '#595959',
        themeTertiary: '#373737',
        themeSecondary: '#2f2f2f',
        themeDarkAlt: '#252525',
        themeDark: '#151515',
        themeDarker: '#0b0b0b',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    },
    extendedPalette: {
        accent: '#00B2A9',
        accentDarker: '#007f79',
        highlight: '#EBF6FD',
    },
    brandPalette: defaultCscBrandPalette,
};

export const grayTheme: ICorptaxThemeSettings = {
    palette: {
        themePrimary: '#54585a',
        themeLighterAlt: '#f8f8f8',
        themeLighter: '#e2e4e4',
        themeLight: '#c9cccd',
        themeTertiary: '#95999c',
        themeSecondary: '#666b6d',
        themeDarkAlt: '#4b4e50',
        themeDark: '#3f4244',
        themeDarker: '#2e3132',
        neutralLighterAlt: '#faf9f8',
        neutralLighter: '#f3f2f1',
        neutralLight: '#edebe9',
        neutralQuaternaryAlt: '#e1dfdd',
        neutralQuaternary: '#d0d0d0',
        neutralTertiaryAlt: '#c8c6c4',
        neutralTertiary: '#a19f9d',
        neutralSecondary: '#605e5c',
        neutralPrimaryAlt: '#3b3a39',
        neutralPrimary: '#323130',
        neutralDark: '#201f1e',
        black: '#000000',
        white: '#ffffff',
    },
    extendedPalette: {
        accent: '#003B5C',
        accentDarker: '#1c5b80',
        highlight: '#EBF6FD',
    },
    brandPalette: defaultCscBrandPalette,
};
